import { IMAGES, MANIFESTO, STATS } from "../lib/data";
import { PageHero } from "../components/PageHero";
import { FadeUp, SectionHead } from "../components/Reveal";
import { CtaSection } from "../components/CtaSection";

const Story = () => (
  <section className="mx-auto w-full max-w-7xl px-6 pb-28 lg:px-10">
    <div className="grid items-start gap-16 lg:grid-cols-5">
      <FadeUp className="relative lg:col-span-2">
        <div
          className="absolute -left-4 -top-4 h-full w-full border border-gold/30"
          aria-hidden="true"
        />
        <img
          src={IMAGES.office}
          alt="Kantor YLBH Sumatera Timur"
          className="relative aspect-[3/4] w-full object-cover"
        />
      </FadeUp>

      <div className="lg:col-span-3">
        <FadeUp>
          <h2 className="font-serif text-3xl leading-snug text-[#F5F5F5] lg:text-4xl">
            Berdiri sejak 2016, untuk rakyat yang kehilangan akses pada
            keadilan.
          </h2>
        </FadeUp>
        <FadeUp delay={0.15}>
          <div className="mt-8 space-y-6 text-base font-light leading-relaxed text-[#A3A3A3] md:text-lg">
            <p>
              YLBH Sumatera Timur lahir pada tahun 2016, ketika gelombang
              pemutusan hubungan kerja dan sengketa tanah melanda Sumatera
              Utara — dan sebagian besar korbannya tidak mampu membayar
              pengacara. Sekelompok advokat muda di Tebing Tinggi membuka meja
              konsultasi gratis di sebuah ruko kecil, dan tidak pernah berhenti
              sejak itu.
            </p>
            <p>
              Hari ini, yayasan kami menaungi 8 advokat dan
              paralegal yang melayani 8 kabupaten dan kota — dari perkara
              pidana di pengadilan negeri hingga pendampingan petani
              menghadapi klaim lahan sepihak. Kami menangani perkara korporat
              dengan standar tertinggi, dan perkara masyarakat tidak mampu
              dengan standar yang sama.
            </p>
            <p>
              Bagi kami, bantuan hukum bukan sedekah. Ia adalah pelaksanaan
              amanat konstitusi bahwa setiap warga negara sama kedudukannya di
              hadapan hukum.
            </p>
          </div>
        </FadeUp>
      </div>
    </div>

    <div className="mt-24 grid grid-cols-2 gap-px border border-white/10 bg-white/10 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <FadeUp key={s.label} delay={0.08 * i}>
          <div data-testid={`about-stat-${i}`} className="bg-[#0A0A0A] p-8 lg:p-10">
            <p className="font-serif text-4xl text-gold lg:text-5xl">{s.angka}</p>
            <p className="mt-2 text-[11px] font-medium uppercase tracking-[0.25em] text-[#A3A3A3]">
              {s.label}
            </p>
          </div>
        </FadeUp>
      ))}
    </div>
  </section>
);

const Manifesto = () => (
  <section className="border-t border-white/10 bg-[#0A0A0A]">
    <div className="mx-auto w-full max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <SectionHead
        eyebrow="Manifesto Kami"
        titleLines={[
          "Empat bab yang",
          <span key="t" className="italic text-gold">
            tidak bisa ditawar.
          </span>,
        ]}
      />
      <div className="mt-20 grid gap-x-16 gap-y-16 md:grid-cols-2">
        {MANIFESTO.map((m, i) => (
          <FadeUp key={m.nomor} delay={0.1 * i}>
            <div data-testid={`manifesto-${m.nomor}`} className="border-t border-white/15 pt-8">
              <div className="flex items-baseline gap-6">
                <span className="font-serif text-5xl italic text-gold/50">
                  {m.nomor}
                </span>
                <h3 className="font-serif text-3xl text-[#F5F5F5] lg:text-4xl">
                  {m.judul}
                </h3>
              </div>
              <p className="mt-6 max-w-md text-base font-light leading-relaxed text-[#A3A3A3]">
                {m.teks}
              </p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

const Quote = () => (
  <section className="border-t border-white/10">
    <div className="mx-auto w-full max-w-5xl px-6 py-28 text-center lg:py-36">
      <FadeUp>
        <p
          data-testid="about-quote"
          className="font-serif text-3xl italic leading-snug text-[#F5F5F5] sm:text-4xl lg:text-5xl"
        >
          “Hukum yang hanya bisa dibeli orang kaya bukanlah hukum —{" "}
          <span className="text-gold">ia kemewahan yang menyamar.</span>”
        </p>
        <p className="mt-8 text-[11px] font-medium uppercase tracking-[0.35em] text-[#A3A3A3]">
          Agusri Putra P. Nasution, S.H — Direktur Eksekutif YLBH Sumatera Timur
        </p>
      </FadeUp>
    </div>
  </section>
);

export default function Tentang() {
  return (
    <>
      <PageHero
        eyebrow="Tentang YLBH Sumatera Timur"
        titleLines={[
          "Rumah hukum bagi",
          <span key="t" className="italic text-gold">
            semua orang.
          </span>,
        ]}
        description="Lebih dari dua dekade membela mereka yang lemah posisinya di hadapan hukum — dengan standar profesional tertinggi dan hati seorang kawan."
      />
      <Story />
      <Manifesto />
      <Quote />
      <CtaSection
        testid="about-cta"
        lines={[
          "Kenali kami lebih dekat.",
          <span key="t" className="italic text-gold">
            Mulai dari satu percakapan.
          </span>,
        ]}
      />
    </>
  );
}
